import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';
import {DateFormat} from "../../../settings/DateFormat/DateFormat";

export const ReclamacionesService = {
	Listar: (filtro, paginacion) => {
		let params = {
			filtro: {
				id_matriz_riesgo: filtro.id_matriz_riesgo || null,
				/*nombre: filtro.nombre || null,
				curp: filtro.curp || null,
				rfc: filtro.rfc || null,
				id_cat_identificacion: filtro.id_cat_identificacion || null,
				fecha_ingreso: fecha_ingreso || null,*/
				activo: (Number(filtro.activo) === 1 || Number(filtro.activo) === 0) ? Number(filtro.activo) : 'all',
			},
			paginacion: {
				total: paginacion.total || null,
				page: paginacion.page || null,
				limit: paginacion.limit || null
			}
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Reclamaciones_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let fecha_reclamacion = form.fecha_reclamacion ? DateFormat.FormatSql(form.fecha_reclamacion):null;
		let fecha_atencion = form.fecha_atencion ? DateFormat.FormatSql(form.fecha_atencion):null;
		let fecha_resolucion = form.fecha_resolucion ? DateFormat.FormatSql(form.fecha_resolucion):null;
		let fecha_notificacion = form.fecha_notificacion ? DateFormat.FormatSql(form.fecha_notificacion):null;
		let fecha_abono_importe = form.fecha_abono_importe ? DateFormat.FormatSql(form.fecha_abono_importe):null;
		
		let params = {
			id_reclamacion: form.id_reclamacion || '',
			
			razon_social: form.razon_social,
			sector: form.sector,
			numero: form.numero,
			folio_atencion: form.folio_atencion,
			estado_concluido_pendiente: form.estado_concluido_pendiente,
			fecha_reclamacion: fecha_reclamacion,
			fecha_atencion: fecha_atencion,
			entidad_federativa: form.entidad_federativa,
			municipio: form.municipio,
			codigo_postal: form.codigo_postal,
			localidad: form.localidad,
			colonia: form.colonia,
			robo_identidad: form.robo_identidad,
			medio_recepcion_canal: form.medio_recepcion_canal,
			nivel_atencion: form.nivel_atencion,
			fecha_resolucion: fecha_resolucion,
			sentido_resolucion: form.sentido_resolucion,
			fecha_notificacion: fecha_notificacion,
			fecha_abono_importe: fecha_abono_importe,
			tipo_persona: form.tipo_persona,
			sexo: form.sexo,
			edad: form.edad,
			operacion: form.operacion,
			producto: form.producto,
			tipo_credito: form.tipo_credito,
			causa: form.causa,
			monetario: form.monetario,
			id_cat_estado_concluido_pendiente: form.id_cat_estado_concluido_pendiente,
			id_cat_entidad_federativa: form.id_cat_entidad_federativa,
			clave_municipio: form.clave_municipio,
			clave_localidad: form.clave_localidad,
			clave_colonia: form.clave_colonia,
			id_cat_medio_recepcion_canal: form.id_cat_medio_recepcion_canal,
			id_cat_nivel_atencion: form.id_cat_nivel_atencion,
			id_cat_robo_identidad: form.id_cat_robo_identidad,
			id_cat_sentido_resolucion: form.id_cat_sentido_resolucion,
			id_cat_tipo_persona: form.id_cat_tipo_persona,
			id_cat_sexo: form.id_cat_sexo,
			id_cat_monetario: form.id_cat_monetario,
			id_cat_anio: form.id_cat_anio,
			id_cat_trimestre: form.id_cat_trimestre,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Reclamaciones_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let fecha_reclamacion = form.fecha_reclamacion ? DateFormat.FormatSql(form.fecha_reclamacion):null;
		let fecha_atencion = form.fecha_atencion ? DateFormat.FormatSql(form.fecha_atencion):null;
		let fecha_resolucion = form.fecha_resolucion ? DateFormat.FormatSql(form.fecha_resolucion):null;
		let fecha_notificacion = form.fecha_notificacion ? DateFormat.FormatSql(form.fecha_notificacion):null;
		let fecha_abono_importe = form.fecha_abono_importe ? DateFormat.FormatSql(form.fecha_abono_importe):null;
		
		let params = {
			id_reclamacion: form.id_reclamacion || '',
			
			razon_social: form.razon_social,
			sector: form.sector,
			numero: form.numero,
			folio_atencion: form.folio_atencion,
			estado_concluido_pendiente: form.estado_concluido_pendiente,
			fecha_reclamacion: fecha_reclamacion,
			fecha_atencion: fecha_atencion,
			entidad_federativa: form.entidad_federativa,
			municipio: form.municipio,
			codigo_postal: form.codigo_postal,
			localidad: form.localidad,
			colonia: form.colonia,
			robo_identidad: form.robo_identidad,
			medio_recepcion_canal: form.medio_recepcion_canal,
			nivel_atencion: form.nivel_atencion,
			fecha_resolucion: fecha_resolucion,
			sentido_resolucion: form.sentido_resolucion,
			fecha_notificacion: fecha_notificacion,
			fecha_abono_importe: fecha_abono_importe,
			tipo_persona: form.tipo_persona,
			sexo: form.sexo,
			edad: form.edad,
			operacion: form.operacion,
			producto: form.producto,
			tipo_credito: form.tipo_credito,
			causa: form.causa,
			monetario: form.monetario,
			id_cat_estado_concluido_pendiente: form.id_cat_estado_concluido_pendiente,
			id_cat_entidad_federativa: form.id_cat_entidad_federativa,
			clave_municipio: form.clave_municipio,
			clave_localidad: form.clave_localidad,
			clave_colonia: form.clave_colonia,
			id_cat_medio_recepcion_canal: form.id_cat_medio_recepcion_canal,
			id_cat_nivel_atencion: form.id_cat_nivel_atencion,
			id_cat_robo_identidad: form.id_cat_robo_identidad,
			id_cat_sentido_resolucion: form.id_cat_sentido_resolucion,
			id_cat_tipo_persona: form.id_cat_tipo_persona,
			id_cat_sexo: form.id_cat_sexo,
			id_cat_monetario: form.id_cat_monetario,
			id_cat_anio: form.id_cat_anio,
			id_cat_trimestre: form.id_cat_trimestre,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Reclamaciones_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_matriz_riesgo) => {let params = {
			id_matriz_riesgo: id_matriz_riesgo
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Reclamaciones_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
};
